import addDays from 'date-fns/add_days';
import subDays from 'date-fns/sub_days';

/**
 * Return a date based on the index. The react list doesn't understand
 * dates, and only returns an index for the column.
 *
 * @param {int} index
 * @param {int} startDaysOffset
 * @return {Date}
 */
export default (index, startDaysOffset = 0) => {
  const offset = index + startDaysOffset;

  if (offset === 0) {
    return new Date();
  } else if (offset < 0) {
    return subDays(new Date(), Math.abs(offset));
  } else {
    return addDays(new Date(), offset);
  }
};



// WEBPACK FOOTER //
// ./src/utils/getDateForIndex.js